<template>
    <div class="release_add no-trans" v-loading="loading">
        <div class="release_add_box">
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > 发布案例
            </div>
            <div class="bom_box">
                <div class="bom_titles">发布点评</div>
                <div class="form_box">
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            标题
                        </div>
                        <div class="form_inputs1">
                            <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            案由
                        </div>
                        <div class="form_inputs5">
                            <el-cascader placeholder="请选择案由" clearable v-model="cause_ac" :options="cause_list"  :props="cause_props"></el-cascader>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            判决书
                        </div>
                        <div class="form_inputs3">
                            <div class="input_btns">
                                <div class="btns"  @click="handle_img_add('judgment')">
                                    <img src="@/assets/img/index/comments_case/file_up.png" alt="">
                                    上传
                                </div>
                                <div class="tishi">
                                    格式为JPG、RAR、PDF、Word
                                </div>
                            </div>
                            <div class="file_list">
                                <div class="item_flex" v-for="(item,index) in judgment" :key="index">
                                    <div class="file_url">{{ item.name }}</div>
                                    <div class="file_clear">
                                        <img src="@/assets/img/index/comments_case/clear.png" alt="" @click="handle_clear(index,'judgment')">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            描述
                        </div>
                        <div class="form_inputs4">
                            <el-input type="textarea" v-model="form.desc"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            提出审判异议
                        </div>
                        <div class="form_inputs4">
                            <el-input type="textarea" v-model="form.trial_obj"></el-input>
                        </div>
                    </div>
                    <div class="form_flex"  v-if="$route.query.type>1">
                        <div class="form_titles">
                            <span>*</span>
                            证据清单及文件
                        </div>
                        <div class="form_inputs3">
                            <div class="input_btns">
                                <div class="btns" @click="handle_img_add('evidence_file')">
                                    <img src="@/assets/img/index/comments_case/file_up.png" alt="">
                                    上传
                                </div>
                                <div class="tishi">
                                    格式为JPG、RAR、PDF、Word
                                </div>
                            </div>
                            <div class="file_list">
                                <div class="item_flex" v-for="(item,index) in evidence_file" :key="index" >
                                    <div class="file_url">{{ item.name }}</div>
                                    <div class="file_clear">
                                        <img src="@/assets/img/index/comments_case/clear.png" alt="" @click="handle_clear(index,'evidence_file')">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex" v-if="$route.query.type>2">
                        <div class="form_titles">
                            <span>*</span>
                            庭审笔录（阅卷）
                        </div>
                        <div class="form_inputs3">
                            <div class="input_btns">
                                <div class="btns"  @click="handle_img_add('record_file')">
                                    <img src="@/assets/img/index/comments_case/file_up.png" alt="">
                                    上传
                                </div>
                                <div class="tishi">
                                    格式为JPG、RAR、PDF、Word
                                </div>
                            </div>
                            <div class="file_list">
                                <div class="item_flex" v-for="(item,index) in record_file" :key="index">
                                    <div class="file_url">{{ item.name }}</div>
                                    <div class="file_clear">
                                        <img src="@/assets/img/index/comments_case/clear.png" alt="" @click="handle_clear(index,'record_file')">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            纠纷发生地
                        </div>
                        <div class="form_inputs5">
                            <el-cascader placeholder="请选择纠纷发生地" clearable v-model="happen_area" :options="area_list"  :props="props"></el-cascader>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            委托人所住地
                        </div>
                        <div class="form_inputs5">
                            <el-cascader placeholder="请选择委托人所住地" clearable v-model="area_ac" :options="area_list"  :props="props"></el-cascader>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                            <span>*</span>
                            增值服务
                        </div>
                        <div class="form_inputs6">
                            <el-radio-group v-model="form.if_add">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                        </div>
                        <div class="form_inputs7">
                            <div class="check_list">
                                <div class="check_item" v-for="(item,index) in check_list" :key="index" :class="{check_item_ac:item.type==form.easy}" role="radio" :aria-checked="item.type==form.easy" tabindex="0" @keydown.enter.prevent="handle_type(item)" @keydown.space.prevent="handle_type(item)" @click="handle_type(item)">
                                    <div class="chekc_ac" v-if="item.type==form.easy">
                                        <img src="@/assets/img/index/legal/check_ac.png" alt="">
                                    </div>
                                    <div class="check_title">{{ item.title }}</div>
                                    <div class="check_imgs">
                                        <div class="imgs" v-if="form.easy!=item.type"><img :src="item.imgs" alt="" ></div>
                                        <div class="imgs" v-if="form.easy==item.type"><img :src="item.imgs_ac" alt="" ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                           
                        </div>
                        <div class="form_inputs6">
                            <el-radio-group v-model="form.proceed">
                                <el-radio :label="1">诉讼服务</el-radio>
                                <el-radio :label="2">非诉讼服务</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                           
                        </div>
                        <div class="form_inputs8">
                            <div>
                                <el-checkbox :true-label="1" :false-label="0" label="公开案例信息" name="type" v-model="form.if_open_case"></el-checkbox>
                            </div>
                            <div>                                
                                <el-checkbox  :true-label="1" :false-label="0" label="公开律师填写的点评内容" name="type" v-model="form.if_open_comment"></el-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_titles">
                           
                        </div>
                        <div class="form_inputs9">
                            <div class="form_btns" @click="handle_end">
                                提交
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>

    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import upload from '@/components/upload/upload.vue'


export default {
    components: {
        upload,

    },
    name: "homes",
    data() {
        return {
            loading: false,
            types:JSON.stringify(['jpg','png','rar','pdf','docx']),
            
            cause_list:[],//案由列表
            area_list: [],
            happen_area:[],//纠纷发生
            area_ac:[],//委托人
            cause_ac:[],//案由
            cause_props:{
                label:'title',
                value:'id',
                children:'child',
            },
            props:{
                label:'name',
                value:'name',
                children:'children',
            },
        
            check_list:[
                {
                    title:'简单咨询',//
                    type:1,
                    imgs:require('../../../assets/img/index/legal/check_1_1.png'),
                    imgs_ac:require('../../../assets/img/index/legal/check_1_2.png'),

                },
                {
                    title:'详细咨询',
                    type:2,
                    imgs:require('../../../assets/img/index/legal/check_2_1.png'),
                    imgs_ac:require('../../../assets/img/index/legal/check_2_2.png'),
                }
            ],
            form:{
                grade:'',//等级1初级2中级3高级4特级
                title:'',//标题
                cateid:'',//1级分类
                cateid2:'',//2级分类
                cateid3:'',//3级分类
                judgment:'',//裁决书
                desc:'',//简介描述
                trial_obj:'',//提出审判异议
                evidence_file:'',//证据清单及文件
                record_file:'',//庭审笔录
                happen_province:'',//发生省
                happen_city:'',//发生市
                happen_area:'',//发生区
                province:'',//省
                city:'',//市 
                area:'',//区
                if_add:1,//增值服务 1是 0否
                easy:1,//1简单咨询 2详细咨询
                proceed:1,//1诉讼 2非
                if_open_case:0,//案例信息公开 1
                if_open_comment:0,//公开律师填写的点评内容
            },
            judgment:[],//裁决书
            evidence_file:[],//证据清单及文件
            record_file:[],//庭审笔录
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.form.grade=this.$route.query.type
        this.get_cause_list()
        this.get_area()

    },
    methods: {
          //获取地区列表
          get_area(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.area_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //获取分类
        get_cause_list(){
            this.$api("cause", {
                
				// type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.cause_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //触发上传
        handle_img_add(text){
            let datas={
                form_title:text,
            }
            this.$refs.uploads.uploadFile(datas)
        },
        //上传图片
        upload_url(res_data,datas){
            this[datas.form_title].push(res_data)
        },
        //删除图片
        handle_clear(index,text){
            this[text].splice(index,1)
        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_type(item){
            this.form.easy=item.type
        },
        handle_end(){
            if(!this.form.title){
                alertErr('请输入标题')
                return
            }
            if(this.cause_ac.length==0){
                alertErr('请选择案由')
                return
            }
            this.form.cateid=this.cause_ac[0]
            this.form.cateid2=this.cause_ac[1]
            this.form.cateid3=this.cause_ac[2]
            if(this.judgment.length==0){
                alertErr('请上传判决书')
                return
            }
            this.form.judgment=JSON.stringify(this.judgment)


            
            if(!this.form.desc){
                alertErr('请输入描述')
                return
            }
            if(!this.form.trial_obj){
                alertErr('请输入提出审判异议')
                return
            }
            if(this.evidence_file.length==0&&this.form.grade>1){
                alertErr('请上传证据清单及文件')
                return
            }
            if(this.evidence_file.length!=0&&this.form.grade>1){
                this.form.evidence_file=JSON.stringify(this.evidence_file)
            }

            if(this.record_file.length==0&&this.form.grade>2){
                alertErr('请上传庭审笔录')
                return
            }
            if(this.record_file.length!=0&&this.form.grade>1){
                this.form.record_file=JSON.stringify(this.record_file)
            }
            if(this.happen_area.length==0){
                alertErr('请选择纠纷发生地')
                return
            }
            this.form.happen_province=this.happen_area[0]
            this.form.happen_city=this.happen_area[1]
            this.form.happen_area=this.happen_area[2]
            if(this.area_ac.length==0){
                alertErr('请选择委托人所住地')
                return
            }
            this.form.province=this.area_ac[0]
            this.form.city=this.area_ac[1]
            this.form.area=this.area_ac[2]
          
            console.log('this.form',this.form)
         
            this.$api("casePublish", {
				...this.form,
                pay_money:this.$route.query.price
			}, "post").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                       this.$router.push({
                            path:'/release_pay',
                            query:{
                                id:res.data.order_id,
                                price:this.$route.query.price
                            }
                        })
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.release_add {
    padding-bottom: 80px;
    background-color: #F5F5F5;
    .release_add_box{
        width: 1440px;
        margin: auto;
        // height: 100px;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .bom_box{
            padding:0 77px;
            background-color: #fff;  
            .bom_titles{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 28px;
                color: #333333;
                padding: 40px 0 44px 0;
                border-bottom: 1px solid #E0E3E3;
                text-align: center;
            }
            .form_box{
                // padding: 60px  76px ;
                padding-top: 60px;
                width: 900px;
                margin: auto;
                .form_flex{
                    display: flex;
                    // align-items: center;
                    margin-bottom: 33px;
                    .form_titles{
                        flex-shrink: 0;
                        width: 150px;
                        padding-right: 24px;
                        display: flex;
                        justify-content: flex-end;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        line-height: 40px;
                        span{
                            color: #FD4C5C;
                            margin-right: 5px;
                        }

                    }
                    .form_inputs1{
                        width: 740px;
                    }
                    .form_inputs2{
                        width: 740px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        /deep/.el-select{
                            width: 240px;
                        }

                    }
                    .form_inputs3{
                        width: 740px;
                        .input_btns{
                            display: flex;
                            align-items: center;
                            height: 40px;
                            .btns{
                                width: 88px;
                                height: 28px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #377CFD;
                                cursor: pointer;
                                img{
                                   width: 10px; 
                                   height: 10px;
                                   margin-right: 6px;
                                }
                            }
                            .tishi{
                                margin-left: 24px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #999999;

                            }
                        }
                        .file_list{
                            padding-top: 16px;
                            .item_flex{
                                display: flex;
                                align-items: center;
                                margin-bottom: 10px;
                                .file_url{
                                    font-family: SourceHanSansSC-Regular, SourceHanSansSC-Regular;
                                    font-weight: normal;
                                    font-size: 14px;
                                    color: #333333;
                                }
                                .file_clear{
                                    img{
                                        width: 12px;
                                        height: 12px;
                                        cursor: pointer;
                                        margin-left: 17px;
                                    }
                                }
                            }
                        }

                    }
                    .form_inputs4{
                        width: 740px;
                        // height: 160px;
                        /deep/.el-textarea{
                            // height: 160px;
                            textarea{
                                height: 160px;
                            }
                        }
                        
                    }
                    .form_inputs5{
                        width: 740px;
                        /deep/.el-cascader{
                            width: 100%;
                        }

                    }
                    .form_inputs6{
                        width: 740px;
                        display: flex;
                        align-items: center;
                        
                    }
                    .form_inputs7{
                        width: 740px;
                        .check_list{
                            display: flex;
                            align-items: center;
                            .check_item{
                                width: 158px;
                                height: 138px;
                                background: #FFFFFF;
                                border-radius: 6px 6px 6px 6px;
                                border: 1px solid #B8C4D1;
                                cursor: pointer;
                                margin-right: 56px;
                                position: relative;
                                .chekc_ac{
                                    position: absolute;
                                    right: 0;
                                    bottom: 0;
                                    img{
                                        width: 37px;
                                        height: 37px;
                                    }
                                }
                                .check_title{
                                    padding-top: 16px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #333333;
                                    text-align: center;
                                }
                                .check_imgs{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding-top: 14px;
                                    .imgs{
                                        width: 72px;
                                        height: 64px;
                                    }
                                }
                            }
                            .check_item_ac{
                                border-color:#377CFD ;
                            }
                        }

                    }
                    .form_inputs8{

                    }
                    .form_inputs9{
                        padding-bottom: 76px;
                        .form_btns{
                            width: 134px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }
    }
    

     
     
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .release_add.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .release_add.no-trans .release_add_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .release_add.no-trans .release_add_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .release_add.no-trans .release_add_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .release_add.no-trans .release_add_box .bom_box {
        padding: 0 16px;
    }
    .release_add.no-trans .release_add_box .bom_box .bom_titles {
        font-size: 24px;
        padding: 16px 0 16px 0;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box {
        padding-top: 16px;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_titles {
        width: 150px;
        padding-right: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        line-height: 40px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_titles span {
        margin-right: 5px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs2 /deep/ .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .input_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        min-height: 40px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .input_btns .btns {
        width: 88px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .input_btns .btns img {
        width: 10px;
        height: 10px;
        margin-right: 6px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .input_btns .tishi {
        margin-left: 16px;
        font-size: 14px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .file_list {
        padding-top: 16px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .file_list .item_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 10px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .file_list .item_flex .file_url {
        font-size: 14px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .file_list .item_flex .file_clear img {
        width: 12px;
        height: 12px;
        margin-left: 16px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs4 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs4 /deep/ .el-textarea textarea {
        min-height: 0;
        height: auto;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs5 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs6 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs7 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs7 .check_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs7 .check_list .check_item {
        width: 158px;
        min-height: 44px;
        height: auto;
        border-radius: 6px 6px 6px 6px;
        margin-right: 16px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs7 .check_list .check_item .chekc_ac img {
        width: 37px;
        height: 37px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs7 .check_list .check_item .check_title {
        padding-top: 16px;
        font-size: 14px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs7 .check_list .check_item .check_imgs {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 14px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs7 .check_list .check_item .check_imgs .imgs {
        width: 72px;
        height: 64px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs9 {
        padding-bottom: 16px;
    }
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs9 .form_btns {
        width: 134px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
    }
}
@media (max-width: 1024px) {
    .release_add.no-trans {
        background: #f5f6f8;
        padding: 0 12px 24px;
        box-sizing: border-box;
        .release_add_box {
            max-width: 720px;
            .top_box { padding: 4px 2px; gap: 4px; min-height: 44px; font-size: 13px; }
            .top_box .span1 { display: inline-flex; align-items: center; min-height: 44px; }
            .bom_box {
                padding: 0 16px;
                background: #fff;
                .bom_titles { padding: 20px 0 16px; font-size: 20px; line-height: 28px; text-align: left; border-bottom: 1px solid #edf0f4; }
                .form_box {
                    padding-top: 20px;
                    .form_flex {
                        gap: 8px;
                        margin-bottom: 22px;
                        .form_titles { width: auto; padding: 0; gap: 0; justify-content: flex-start; font-size: 15px; line-height: 22px; color: #303744; }
                        .form_titles:empty { display: none; }
                        /deep/ .el-input__inner { height: 46px; line-height: 46px; padding-left: 12px; font-size: 16px; border-color: #dce1e8; border-radius: 4px; }
                        /deep/ .el-cascader { width: 100%; line-height: 46px; }
                        .form_inputs4 /deep/ .el-textarea textarea { box-sizing: border-box; min-height: 128px; padding: 10px 12px; font-size: 16px; line-height: 1.7; border-color: #dce1e8; border-radius: 4px; }
                        .form_inputs3 {
                            .input_btns { gap: 8px 12px; }
                            .input_btns .btns { box-sizing: border-box; width: 100px; min-height: 44px; padding: 0; gap: 0; }
                            .input_btns .btns img { width: 16px; height: 16px; }
                            .input_btns .tishi { margin: 0; font-size: 13px; line-height: 22px; color: #7b8491; }
                            .file_list { padding-top: 8px; }
                            .file_list:empty { display: none; }
                            .file_list .item_flex { flex-wrap: nowrap; gap: 8px; margin: 0 0 6px; padding-left: 10px; background: #f5f7fa; border-radius: 4px; }
                            .file_list .item_flex .file_url { flex: 1; min-width: 0; overflow-wrap: anywhere; font-size: 13px; line-height: 22px; }
                            .file_list .item_flex .file_clear { flex: 0 0 44px; }
                            .file_list .item_flex .file_clear img { box-sizing: border-box; display: block; width: 44px; height: 44px; margin: 0; padding: 15px; cursor: pointer; }
                        }
                        .form_inputs7 .check_list {
                            display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px;
                            .check_item { box-sizing: border-box; width: auto; margin: 0; padding: 12px; border: 1px solid #dce1e8; border-radius: 6px; display: flex; align-items: center; justify-content: center; gap: 10px; }
                            .check_item_ac { border-color: #1677d2; background: #eff7ff; color: #1677d2; }
                            .check_item:focus-visible { outline: 2px solid #1677d2; outline-offset: 2px; }
                            .check_item .check_title { padding: 0; font-size: 14px; }
                            .check_item .check_imgs { padding: 0; order: -1; }
                            .check_item .check_imgs .imgs { width: 30px; height: 28px; }
                            .check_item .chekc_ac img { width: 22px; height: 22px; }
                        }
                        .form_inputs6 /deep/ .el-radio-group { display: flex; flex-wrap: wrap; gap: 4px 24px; }
                        .form_inputs6 /deep/ .el-radio { display: inline-flex; align-items: center; min-height: 44px; margin: 0; }
                        /deep/ .el-radio__inner { width: 20px; height: 20px; }
                        /deep/ .el-radio__inner::after { width: 8px; height: 8px; }
                        /deep/ .el-radio__label { font-size: 14px; padding-left: 8px; }
                        .form_inputs8 { width: 100%; padding: 10px 0; border-top: 1px solid #edf0f4; }
                        .form_inputs8 /deep/ .el-checkbox { display: flex; align-items: center; min-height: 44px; white-space: normal; }
                        /deep/ .el-checkbox__inner { width: 20px; height: 20px; }
                        /deep/ .el-checkbox__inner::after { width: 5px; height: 10px; left: 6px; top: 2px; border-width: 2px; }
                        /deep/ .el-checkbox__label { font-size: 14px; line-height: 22px; padding-left: 8px; }
                        .form_inputs9 { width: 100%; padding-bottom: 24px; padding-bottom: ~"max(24px, env(safe-area-inset-bottom))"; }
                        .form_inputs9 .form_btns { width: 100%; height: 48px; line-height: 48px; font-size: 16px; border-radius: 4px; }
                    }
                }
            }
        }
    }
}
@media (max-width: 480px) {
    .release_add.no-trans .release_add_box .bom_box .form_box .form_flex .form_inputs3 .input_btns .tishi { width: 100%; }
}
</style>
